import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import * as siteMaster from '../../../data/actions/siteActions'
import { shouldRemountDrawerContent } from './drawerContentKey'

function hasValidDrawerContent(content) {
    return Boolean(content && React.isValidElement(content))
}

@connect((store) => {
    return { siteMaster: store.siteMaster }
})
export default class Drawer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            firstRun: true,
            shouldSlideOut: false,
            lastContent: null,
            contentKey: 0
        }
        this.closeDrawer = this.closeDrawer.bind(this)
        this.handleAllClicks = this.handleAllClicks.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.standalone && this.props.isOpen !== undefined) {
            if (this.props.isOpen !== this.state.isOpen) {
                this.setState({
                    isOpen: this.props.isOpen,
                    firstRun: false,
                    shouldSlideOut: this.state.isOpen && !this.props.isOpen
                })
            }
        } else {
            var thisDrawer = this.props.siteMaster.siteDrawer
            var thisPage = this.props.siteMaster.currentPage

            if (thisDrawer && thisDrawer != prevProps.siteMaster.siteDrawer) {
                const wantsOpen = Boolean(thisDrawer.isOpen) && hasValidDrawerContent(thisDrawer.content)
                const nextState = {
                    isOpen: wantsOpen,
                    firstRun: false,
                    shouldSlideOut: this.state.isOpen && !wantsOpen
                }
                if (hasValidDrawerContent(thisDrawer.content)) {
                    nextState.lastContent = thisDrawer.content
                    // Remount when content changes so EmailPreviewer/etc. do not go stale.
                    // Skip remount on width-only updates (alterSiteDrawerWidth) — remounting
                    // would wipe nested state such as the automation multi-sender rules UI.
                    if (
                        shouldRemountDrawerContent({
                            wantsOpen,
                            nextContent: thisDrawer.content,
                            prevContent: prevProps.siteMaster.siteDrawer?.content
                        })
                    ) {
                        nextState.contentKey = Date.now()
                    }
                }
                this.setState(nextState)

                const path = window.location.pathname
                if (wantsOpen && path !== '/cp/subscribers' && path.indexOf('/cp/groups/') !== 0) {
                    document.body.classList.add('remove-overflow')
                } else {
                    document.body.classList.remove('remove-overflow')
                }
            }

            if (this.state.isOpen && !prevState.isOpen && thisDrawer?.obscureContent) {
                const el = document.getElementById('opaque-background')
                if (el && !el.classList.contains('opaque-background_open')) {
                    el.classList.add('opaque-background_open')
                }
                this.setState({ opaque: true })
            }

            if (!this.state.isOpen && prevState.isOpen && this.state.opaque) {
                const el = document.getElementById('opaque-background')
                if (el && el.classList.contains('opaque-background_open')) {
                    el.classList.remove('opaque-background_open')
                }
                this.setState({ opaque: false })
            }

            if (thisPage != prevProps.siteMaster.currentPage) {
                document.body.classList.remove('remove-overflow')
                this.setState({
                    isOpen: false,
                    firstRun: true,
                    shouldSlideOut: false,
                    lastContent: null,
                    contentKey: 0
                })
            }
        }
    }

    componentDidMount() {
        if (this.props.standalone) {
            if (this.props.persist) {
                // this.setState({ firstRun: false })
            } else if (this.props.isOpen || this.props.isOpen === undefined) {
                this.setState({
                    isOpen: true,
                    firstRun: false,
                    shouldSlideOut: false
                })
                document.body.classList.add('remove-overflow')
            }
        }
        if (this.props.clickOutside === true) {
            document.addEventListener('click', this.handleAllClicks, false)
        }
    }

    componentWillUnmount() {
        if (!this.props.ignoreOverflow) {
            document.body.classList.remove('remove-overflow')
            if (this.props.clickOutside === true) {
                document.removeEventListener('click', this.handleAllClicks, false)
            }
        }
    }

    closeDrawer(event) {
        if (event && typeof event.stopPropagation === 'function') {
            event.stopPropagation()
            event.preventDefault()
        }
        if (this.props.standalone) {
            if (this.props.startClose && typeof this.props.startClose === 'function') {
                this.props.startClose()
            }
            this.setState(
                {
                    isOpen: false,
                    shouldSlideOut: true
                },
                () => {
                    setTimeout(this.props.close, 500)
                }
            )
        } else {
            if (this.props.siteMaster.siteDrawer.onClose) {
                this.props.siteMaster.siteDrawer.onClose(event)
            }

            this.props.dispatch(
                siteMaster.alterSiteDrawer(
                    false,
                    this.props.siteMaster.siteDrawer.showClose,
                    this.props.siteMaster.siteDrawer.direction,
                    null,
                    false,
                    this.props.siteMaster.siteDrawer.width,
                    this.props.siteMaster.siteDrawer.className
                )
            )
        }
    }

    handleAllClicks(event) {
        if (
            !ReactDOM.findDOMNode(this).contains(event.target) &&
            !ReactDOM.findDOMNode(this).contains(event.currentTarget) &&
            event.target.className.indexOf('header-label') == -1
        ) {
            this.closeDrawer()
        }
    }

    render() {
        const liveContent = this.props.standalone ? this.props.children : this.props.siteMaster.siteDrawer?.content
        const hasLiveContent = this.props.standalone || hasValidDrawerContent(liveContent)
        const content = hasLiveContent ? liveContent : this.state.lastContent

        var theClasses = ''
        if (this.state.firstRun === false) {
            if (this.state.isOpen === true && (this.props.standalone || hasValidDrawerContent(content))) {
                theClasses += ' slideIn'
            } else if (this.state.shouldSlideOut) {
                theClasses += ' slideOut'
            }
        }

        if (this.props.standalone) {
            var theStyle = {}
            if (this.props.style) {
                theStyle = { ...this.props.style }
            }

            if (this.props.width) {
                theStyle.width = this.props.width
            }

            if (this.props.className) {
                theClasses += ' ' + this.props.className
            }

            return (
                <div className={'uiDrawer' + theClasses} style={theStyle}>
                    {this.props.showClose && (
                        <div className='exit cyt-cross-drawer-pop' onClick={this.closeDrawer}>
                            <span className='icon-cross2'></span>
                        </div>
                    )}
                    <div className='uiDrawerInner'>{this.props.children}</div>
                </div>
            )
        } else {
            const drawer = this.props.siteMaster.siteDrawer
            const className = drawer && typeof drawer.className === 'string' ? drawer.className : ''

            if (hasValidDrawerContent(content)) {
                var contentStyle = {}

                if (drawer?.width) {
                    contentStyle.width = drawer.width
                }

                if (className) {
                    theClasses += ' ' + className
                }

                return (
                    <div className={'uiDrawer' + theClasses} style={contentStyle}>
                        {drawer?.showClose && (
                            <div className='exit cyt-cross-drawer' onClick={this.closeDrawer}>
                                <span className='icon-cross2'></span>
                            </div>
                        )}
                        <div className='uiDrawerInner' key={this.state.contentKey}>
                            {content}
                        </div>
                    </div>
                )
            } else {
                // Keep a closed, off-screen shell so Cypress can still query `.uiDrawer`.
                return <div className={'uiDrawer' + theClasses}></div>
            }
        }
    }
}
